import { useInstrumentStore } from '../../state/instrumentStore'
import { useArrangementStore } from '../../state/arrangementStore'
import type { TrackId } from '../../constants/scale'
import { toneVar, toneGlow, type Tone } from '../../utils/tones'
import { MuteButton } from './MuteButton'
import './TrackHeader.css'

interface TrackHeaderProps {
  track: TrackId
  label: string
  tone: Tone
}

export function TrackHeader({ track, label, tone }: TrackHeaderProps) {
  const openFxPanel = useInstrumentStore((s) => s.openFxPanel)
  const toggleFxPanel = useInstrumentStore((s) => s.toggleFxPanel)
  const muted = useInstrumentStore((s) => s.trackMutes[track])
  const toggleTrackMute = useInstrumentStore((s) => s.toggleTrackMute)
  const activeTrack = useInstrumentStore((s) => s.activeTrack)
  const setActiveTrack = useInstrumentStore((s) => s.setActiveTrack)
  const arrangementExpanded = useArrangementStore((s) => s.expanded)
  const setArrangementExpanded = useArrangementStore((s) => s.setExpanded)
  const open = openFxPanel === track
  const isCollapsed = activeTrack !== track || arrangementExpanded
  const style = {
    '--tone': toneVar(tone),
    '--tone-glow': toneGlow(tone),
  } as React.CSSProperties
  return (
    <div className={`track-header ${muted ? 'is-muted' : ''}`} style={style}>
      <MuteButton
        muted={muted}
        onToggle={() => toggleTrackMute(track)}
        label={label}
        onClick={(e) => e.stopPropagation()}
      />
      {isCollapsed ? (
        <button
          type="button"
          className="track-header-label track-header-label-btn"
          onClick={(e) => {
            e.stopPropagation()
            if (arrangementExpanded) setArrangementExpanded(false)
            setActiveTrack(track)
          }}
          aria-label={`Expand ${label}`}
        >
          {label}
        </button>
      ) : (
        <span className="track-header-label">{label}</span>
      )}
      <button
        type="button"
        className={`track-header-fx ${open ? 'is-open' : ''}`}
        onClick={(e) => {
          e.stopPropagation()
          toggleFxPanel(track)
        }}
        aria-label={`${label} effects`}
        aria-expanded={open}
      >
        FX
      </button>
    </div>
  )
}
